<div class="w-full h-2/3">
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      class="w-full h-full"
    ></highcharts-chart>
  </div>
  